import { FormationTypes } from "../static/formations";
import { values, invert } from "lodash";
function orderObjectValues(obj) {
    var sortedObject = {};
    values(obj).sort().forEach(function(v) {
        sortedObject[invert(obj)[v]] = v;
    });
    return sortedObject;
}
export function getFormationTypes() {
    var ft = orderObjectValues(FormationTypes);
    delete ft.autres;
    ft.autres = "Autre";
    return ft;
}
